const getIcon = (name, style, extraClassNames) => {
  switch (name) {
    case 'arrow-down':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M7 10l5 5 5-5H7z" />
        </svg>
      );
    case 'arrow-up':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M7 14l5-5 5 5H7z" />
        </svg>
      );
    case 'arrow-right':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" />
        </svg>
      );
    case 'carrier':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
        </svg>
      );
    case 'check-mark':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor">
          <path
            d="m28 7.5-16.74 17-7.26-7.37"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </svg>
      );
    case 'chevron-down':
      return (
        <svg
          className={`icon ${extraClassNames ? extraClassNames : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
        </svg>
      );
    case 'chevron-down-onboarding':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 95 40"
          width="95px"
          height="40px">
          <path d="M2 2L46.764 37L92 2" stroke="currentColor" strokeWidth="3" fill="none" />
        </svg>
      );
    case 'chevron-left':
      return (
        <svg
          className={`icon ${extraClassNames ? extraClassNames : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
        </svg>
      );
    case 'chevron-right':
      return (
        <svg
          className={`icon ${extraClassNames ? extraClassNames : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
        </svg>
      );
    case 'chevron-up':
      return (
        <svg
          className={`icon ${extraClassNames ? extraClassNames : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" />
        </svg>
      );
    case 'error':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
        </svg>
      );
    case 'external-link':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
        </svg>
      );
    case 'food-bank':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          enableBackground="new 0 0 24 24"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <rect fill="none" height="24" width="24" />
          <path d="M12,5.5l6,4.5v9H6v-9L12,5.5 M12,3L4,9v12h16V9L12,3L12,3z M11.5,9.5v3H11v-3h-1v3H9.5v-3h-1v3c0,0.83,0.67,1.5,1.5,1.5v4h1 v-4c0.83,0,1.5-0.67,1.5-1.5v-3H11.5z M13,11.5v3h1V18h1V9.5C13.9,9.5,13,10.4,13,11.5z" />
        </svg>
      );
    case 'help':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
        </svg>
      );
    case 'history':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z" />
        </svg>
      );
    case 'instagram':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 56.7 56.7"
          fill="currentColor"
          version="1.1"
          id="Layer_1"
          x="0px"
          y="0px"
          enableBackground="new 0 0 56.7 56.7">
          <g>
            <path d="M28.2,16.7c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8S41,36.5,41,29.5S35.2,16.7,28.2,16.7z M28.2,37.7 c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2S32.7,37.7,28.2,37.7z" />
            <circle cx="41.5" cy="16.4" r="2.9" />
            <path d="M49,8.9c-2.6-2.7-6.3-4.1-10.5-4.1H17.9c-8.7,0-14.5,5.8-14.5,14.5v20.5c0,4.3,1.4,8,4.2,10.7c2.7,2.6,6.3,3.9,10.4,3.9 h20.4c4.3,0,7.9-1.4,10.5-3.9c2.7-2.6,4.1-6.3,4.1-10.6V19.3C53,15.1,51.6,11.5,49,8.9z M48.6,39.9c0,3.1-1.1,5.6-2.9,7.3 s-4.3,2.6-7.3,2.6H18c-3,0-5.5-0.9-7.3-2.6C8.9,45.4,8,42.9,8,39.8V19.3c0-3,0.9-5.5,2.7-7.3c1.7-1.7,4.3-2.6,7.3-2.6h20.6 c3,0,5.5,0.9,7.3,2.7c1.7,1.8,2.7,4.3,2.7,7.2V39.9L48.6,39.9z" />
          </g>
        </svg>
      );
    case 'invalid':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="1"
          strokeWidth="3px">
          <path d="M7,7,25,25" />
          <path d="M7,25,25,7" />
        </svg>
      );
    case 'invalid-circle':
      return (
        <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
          <circle fill="currentColor" cx="16" cy="16" r="14.25" />
          <path
            fill="currentColor"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeMiterlimit="1"
            d="M10.1,10.1,21.9,21.9"
          />
          <path
            fill="currentColor"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
            strokeMiterlimit="1"
            d="M10.1,21.9,21.9,10.1"
          />
        </svg>
      );
    case 'label':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" />
        </svg>
      );
    case 'lock-circle':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          x="0px"
          y="0px">
          <circle fill="currentColor" cx="16" cy="16" r="14.2" />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth="3px"
            d="M20.7,14.1v-2.8c0-6.3-9.4-6.3-9.4,0v2.8 M10.2,15h11.7v8.5H10.2V15z"
          />
        </svg>
      );
    case 'long-arrow-left':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          enableBackground="new 0 0 24 24"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <rect fill="none" height="24" width="24" />
          <path d="M9,19l1.41-1.41L5.83,13H22V11H5.83l4.59-4.59L9,5l-7,7L9,19z" />
        </svg>
      );
    case 'long-arrow-right':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          enableBackground="new 0 0 24 24"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <rect fill="none" height="24" width="24" />
          <path d="M15,5l-1.41,1.41L18.17,11H2V13h16.17l-4.59,4.59L15,19l7-7L15,5z" />
        </svg>
      );
    case 'pencil':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
        </svg>
      );
    case 'play':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
        </svg>
      );
    case 'print':
      return (
        <svg
          className={`icon ${extraClassNames ? extraClassNames : ''}`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm2-4v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z" />
          <circle cx="18" cy="11.5" r="1" />
        </svg>
      );
    case 'receipt':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          enableBackground="new 0 0 24 24"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M0,0h24v24H0V0z" fill="none" />
          <g>
            <path d="M19.5,3.5L18,2l-1.5,1.5L15,2l-1.5,1.5L12,2l-1.5,1.5L9,2L7.5,3.5L6,2v14H3v3c0,1.66,1.34,3,3,3h12c1.66,0,3-1.34,3-3V2 L19.5,3.5z M15,20H6c-0.55,0-1-0.45-1-1v-1h10V20z M19,19c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3H8V5h11V19z" />
            <rect height="2" width="6" x="9" y="7" />
            <rect height="2" width="2" x="16" y="7" />
            <rect height="2" width="6" x="9" y="10" />
            <rect height="2" width="2" x="16" y="10" />
          </g>
        </svg>
      );
    case 'search':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        </svg>
      );
    case 'star':
      return (
        <svg
          className="icon"
          style={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 51 48"
          width="255"
          height="240">
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
          />
        </svg>
      );
    case 'substitution':
      return (
        <svg
          className="icon"
          style={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 512"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M614.2 334.8C610.5 325.8 601.7 319.1 592 319.1H544V176C544 131.9 508.1 96 464 96h-128c-17.67 0-32 14.31-32 32s14.33 32 32 32h128C472.8 160 480 167.2 480 176v143.1h-48c-9.703 0-18.45 5.844-22.17 14.82s-1.656 19.29 5.203 26.16l80 80.02C499.7 445.7 505.9 448 512 448s12.28-2.344 16.97-7.031l80-80.02C615.8 354.1 617.9 343.8 614.2 334.8zM304 352h-128C167.2 352 160 344.8 160 336V192h48c9.703 0 18.45-5.844 22.17-14.82s1.656-19.29-5.203-26.16l-80-80.02C140.3 66.34 134.1 64 128 64S115.7 66.34 111 71.03l-80 80.02C24.17 157.9 22.11 168.2 25.83 177.2S38.3 192 48 192H96V336C96 380.1 131.9 416 176 416h128c17.67 0 32-14.31 32-32S321.7 352 304 352z" />
        </svg>
      );
    case 'thumb-up':
      return (
        <svg
          className="icon"
          style={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          height="48"
          width="48"
          fill="currentColor">
          <path d="M16.25 44.15q-1.95 0-3.325-1.35-1.375-1.35-1.375-3.35v-20.4q0-.9.325-1.75t1.025-1.55l7.95-8.5q1.05-1.1 2.5-1.425 1.45-.325 2.75.325 1.25.6 1.85 1.975.6 1.375.25 2.925l-1.25 6.1H42.2q1.85 0 3.3 1.45 1.45 1.45 1.45 3.25v1.85q0 .65-.175 1.475-.175.825-.425 1.375l-6 14.05q-.6 1.5-2.1 2.525T35.1 44.15Zm-10.85 0q-1.3 0-2.2-.9-.9-.9-.9-2.2v-20.8q0-1.25.85-2.175.85-.925 2.15-.925h.15q1.25 0 2.175.925.925.925.925 2.175v20.8q0 1.3-.925 2.2-.925.9-2.175.9Z" />
        </svg>
      );
    case 'thumb-down':
      return (
        <svg
          className="icon"
          style={style}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          height="48"
          width="48"
          fill="currentColor">
          <path d="M5.8 30.85q-1.85 0-3.3-1.45-1.45-1.45-1.45-3.3v-1.8q0-.65.175-1.475Q1.4 22 1.65 21.4l6-14q.6-1.5 2.1-2.55 1.5-1.05 3.15-1.05h18.85q1.95 0 3.325 1.375Q36.45 6.55 36.45 8.55v20.4q0 .9-.325 1.75t-.975 1.5l-7.95 8.5q-1.1 1.15-2.55 1.475-1.45.325-2.75-.325-1.25-.6-1.85-1.975-.6-1.375-.25-2.925l1.25-6.1ZM42.65 3.8q1.25 0 2.175.925.925.925.925 2.225v20.8q0 1.25-.875 2.175-.875.925-2.075.925h-.2q-1.3 0-2.225-.925t-.925-2.175V6.95q0-1.3.925-2.225T42.6 3.8Z" />
        </svg>
      );
    case 'unlock':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z" />
        </svg>
      );
    case 'valid-circle':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor">
          <circle fill="currentColor" cx="16" cy="16" r="14.25" />
          <path
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="3px"
            d="M23.09,11,13.2,21,8.91,16.67"
          />
        </svg>
      );
    case 'valid':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="currentColor">
          <path
            d="m28 7.5-16.74 17-7.26-7.37"
            fill="none"
            stroke="#3d3935"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </svg>
      );
    case 'visibility-off':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="m31.45 27.05-2.2-2.2q1.3-3.55-1.35-5.9-2.65-2.35-5.75-1.2l-2.2-2.2q.85-.55 1.9-.8 1.05-.25 2.15-.25 3.55 0 6.025 2.475Q32.5 19.45 32.5 23q0 1.1-.275 2.175-.275 1.075-.775 1.875Zm6.45 6.45-2-2q2.45-1.8 4.275-4.025Q42 25.25 42.85 23q-2.5-5.55-7.5-8.775Q30.35 11 24.5 11q-2.1 0-4.3.4-2.2.4-3.45.95L14.45 10q1.75-.8 4.475-1.4Q21.65 8 24.25 8q7.15 0 13.075 4.075Q43.25 16.15 46 23q-1.3 3.2-3.35 5.85-2.05 2.65-4.75 4.65Zm2.9 11.3-8.4-8.25q-1.75.7-3.95 1.075T24 38q-7.3 0-13.25-4.075T2 23q1-2.6 2.775-5.075T9.1 13.2L2.8 6.9l2.1-2.15L42.75 42.6ZM11.15 15.3q-1.85 1.35-3.575 3.55Q5.85 21.05 5.1 23q2.55 5.55 7.675 8.775Q17.9 35 24.4 35q1.65 0 3.25-.2t2.4-.6l-3.2-3.2q-.55.25-1.35.375T24 31.5q-3.5 0-6-2.45T15.5 23q0-.75.125-1.5T16 20.15Zm15.25 7.1Zm-5.8 2.9Z" />
        </svg>
      );
    case 'visibility-on':
      return (
        <svg
          className="icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          fill="currentColor"
          width="48px"
          height="48px">
          <path d="M24 31.5q3.55 0 6.025-2.475Q32.5 26.55 32.5 23q0-3.55-2.475-6.025Q27.55 14.5 24 14.5q-3.55 0-6.025 2.475Q15.5 19.45 15.5 23q0 3.55 2.475 6.025Q20.45 31.5 24 31.5Zm0-2.9q-2.35 0-3.975-1.625T18.4 23q0-2.35 1.625-3.975T24 17.4q2.35 0 3.975 1.625T29.6 23q0 2.35-1.625 3.975T24 28.6Zm0 9.4q-7.3 0-13.2-4.15Q4.9 29.7 2 23q2.9-6.7 8.8-10.85Q16.7 8 24 8q7.3 0 13.2 4.15Q43.1 16.3 46 23q-2.9 6.7-8.8 10.85Q31.3 38 24 38Zm0-15Zm0 12q6.05 0 11.125-3.275T42.85 23q-2.65-5.45-7.725-8.725Q30.05 11 24 11t-11.125 3.275Q7.8 17.55 5.1 23q2.7 5.45 7.775 8.725Q17.95 35 24 35Z" />
        </svg>
      );
    default:
      return null;
  }
};

const Icon = (props) => {
  if (!props.name) {
    return null;
  }
  return getIcon(props.name, props.style, props.extraClassNames);
};

export default Icon;
